import { getConfigVersion } from "../project-utils";
import { defaultTagTexture } from "../viewer/textures/tag-icons";
import { AssetType, isCameraOrTag } from "./assets-slice";
import { initialAerialState, initialSceneState } from "./camera-slice";
import { currentConfigVersion } from "./project-slice";
import semver from "semver";
import { nanoid } from "@reduxjs/toolkit";

export const upgradeConfig = (config) => {
  config = upgradeVersion34(config);
  config = upgradeVersion35(config);
  config = upgradeVersion36(config);
  config = upgradeVersion37(config);
  config = upgradeVersion38(config);
  config = upgradeVersion39(config);
  config = upgradeVersion310(config);

  /** Additional upgrades go here */

  // Project config should now be at the latest version
  config.project.configVersion = currentConfigVersion;

  return config;
};

const upgradeVersion310 = (config) => {
  const oldVersion = "3.10.0";
  const newVersion = "3.11.0";

  if (semver.gt(getConfigVersion(config), oldVersion)) {
    return config;
  }

  console.log(`Upgrade configuration file: ${oldVersion} --> ${newVersion}`);

  config.assets = config.assets.map(asset => {
    // Add unique id tags / panoramics / planars
    if (isCameraOrTag(asset.type)) {
      asset.data = asset.data.map(tag => {
        return {
          id: nanoid(),
          ...tag
        };
      });
    }

    // Add comments field for tags
    if (asset.type === AssetType.Tag) {
      asset.data = asset.data.map(tag => {
        return {
          ...tag,
          comment: ""
        };
      });
    }

    return asset;
  });

  config.project.configVersion = newVersion;
  return config;
};

const upgradeVersion39 = (config) => {
  const oldVersion = "3.9.0";
  const newVersion = "3.10.0";

  if (semver.gt(getConfigVersion(config), oldVersion)) {
    return config;
  }

  console.log(`Upgrade configuration file: ${oldVersion} --> ${newVersion}`);

  const extent = config.camera.aerialState.extent;
  const resolution = config.camera.aerialState.resolution;

  // Update camera state
  config.camera.sceneState = {
    ...initialSceneState,
    ...config.camera.sceneState
  };

  // Update aerial state
  config.camera.aerialState = {
    ...initialAerialState,
    ...config.camera.aerialState
  };

  // Convert resolution to zoom
  if (resolution) {
    const zoom = Math.log2(156543.03390625) - Math.log2(resolution);
    config.camera.aerialState.zoom = zoom;
  }

  // Convert extent to center
  if (extent) {
    config.camera.aerialState.center = [
      (extent[0] + extent[2]) / 2,
      (extent[1] + extent[3]) / 2
    ];
  }

  delete config.camera.aerialState.resolution;
  delete config.camera.aerialState.extent;

  config.project.configVersion = newVersion;
  return config;
};

const upgradeVersion38 = (config) => {
  const oldVersion = "3.8.0";
  const newVersion = "3.9.0";

  if (semver.gt(getConfigVersion(config), oldVersion)) {
    return config;
  }

  console.log(`Upgrade configuration file: ${oldVersion} --> ${newVersion}`);

  // Add default texture for tags
  config.assets = config.assets.map(asset => {
    asset.texture = (asset.type === AssetType.Tag) ? defaultTagTexture : undefined;
    return asset;
  });

  config.project.configVersion = newVersion;
  return config;
};

const upgradeVersion37 = (config) => {
  const oldVersion = "3.7.0";
  const newVersion = "3.8.0";

  if (semver.gt(getConfigVersion(config), oldVersion)) {
    return config;
  }

  console.log(`Upgrade configuration file: ${oldVersion} --> ${newVersion}`);

  // Apply upgrades
  delete config.settings.orthoOpacity;
  delete config.settings.orthoQuality;
  delete config.settings.controlType;

  config.project.configVersion = newVersion;
  return config;
};

const upgradeVersion36 = (config) => {
  const oldVersion = "3.6.0";
  const newVersion = "3.7.0";

  if (semver.gt(getConfigVersion(config), oldVersion)) {
    return config;
  }

  console.log(`Upgrade configuration file: ${oldVersion} --> ${newVersion}`);

  // NOTE: Upgrades removed because of refactoring

  config.project.configVersion = newVersion;
  return config;
};

const upgradeVersion35 = (config) => {
  const oldVersion = "3.5.0";
  const newVersion = "3.6.0";

  if (semver.gt(getConfigVersion(config), oldVersion)) {
    return config;
  }

  console.log(`Upgrade configuration file: ${oldVersion} --> ${newVersion}`);

  // Apply upgrades
  config.settings.cloudMaxPoints = config.settings.cloudMaxPoints/1000000;
  config.settings.cloudDistance = config.settings.cloudDistance * 10;

  config.project.configVersion = newVersion;
  return config;
};

const upgradeVersion34 = (config) => {
  const oldVersion = "3.4.0";
  const newVersion = "3.5.0";

  if (semver.gt(getConfigVersion(config), oldVersion)) {
    return config;
  }

  console.log(`Upgrade configuration file: ${oldVersion} --> ${newVersion}`);

  // NOTE: Upgrades removed because of refactoring

  config.project.configVersion = newVersion;
  return config;
};

